<article class="peer-card">
  <div class="peer-card__avatar">{{ peer.initials }}</div>
  <div class="peer-card__body">
    <div class="peer-card__head">
      <div>
        <h4>@{{ peer.handle }}</h4>
        <p>{{ peer.sharedExperience }}</p>
      </div>
      <button type="button" class="follow-btn" [class.follow-btn--active]="isFollowing()" (click)="toggleFollow()">
        {{ isFollowing() ? 'Following' : 'Follow' }}
      </button>
    </div>
  </div>
</article>
